<template>
  <div>
    <SpFinder
      id="1"
      ref="finder"
      :url="{
        data: requestUrl
      }"
      :search="[{ key: 'searchname', name: '', slot: 'searchname' }]"
      :hooks="{
        beforeSearch: beforeSearch
      }"
      title="数据"
      :show-tool-bar="false"
      :columns="columns"
      :actions="actions"
      @reset="onFinderResetGroup"
    >
      <template v-slot:searchname>
        <el-input
          v-model="keyword"
          placeholder="请输入名称"
        />
      </template>
    </SpFinder>
    <!-- 执行群聊 -->
  </div>
</template>
<script>
import { updateStatus } from '@/api/membership/membershipsop'
export default {
  name: 'ShipSopList',
  data () {
    const columns = [
      {
        name: '名称', // 表头
        key: 'rule_name' // 匹配data key
      },
      {
        name: '创建时间',
        key: 'created_at'
      },
      {
        name: '开关',
        key: 'is_active',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return (
            <div>
              <el-switch
                v-model={row.is_active}
                active-text='已开启'
                nativeOnClick={(e) => this.handleTagClick(e, row)}
              ></el-switch>
            </div>
          )
        }
      }
    ]

    const actions = [
      {
        name: '创建规则',
        key: 'create', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          type: 'link',
          path: '/membership/membershipSopAdd'
        }
      },
      {
        name: '添加群聊',
        key: 'edit',
        type: 'button',
        action: {
          type: 'dialog',
          title: '选择群聊',
          aType: 'select',
          component: () => import('@/view/resource/membership/chatList.vue')
        }
      },
      {
        name: '更新群聊',
        key: 'edit',
        type: 'button',
        action: {
          type: 'dialog',
          title: '更新群聊',
          aType: 'update',
          component: () => import('@/view/resource/membership/chatList.vue')
        }
      },
      {
        name: '详情',
        key: 'detail',
        type: 'button',
        action: {
          type: 'link',
          path: (row, selections) => `/membership/membershipSop/${row.id}` // 字符串方式跳转
        }
      },
      {
        name: '编辑',
        key: 'edit',
        type: 'button',
        action: {
          type: 'link',
          path: (row, selections) => `/membership/membershipSopAdd/${row.id}` // 方法方式跳转
        }
      },
      {
        name: '删除',
        key: 'delete',
        type: 'button',
        action: {
          type: 'api',
          path: '/salesperson/sop/delete/${id}', // api url
          onSuccess: () => {
            this.$refs.finder.refresh()
          },
          confirm: {
            message: '请确认是否删除？',
            title: '提示'
          }
        }
      }
    ]

    return {
      columns,
      actions,
      requestUrl: process.env.VUE_APP_BASE_API + '/salesperson/sop/list',
      keyword: ''
    }
  },

  methods: {
    handleTagClick (e, row) {
      const popoverEl = e.target.parentNode.parentNode
      // setTimeout(() => {
      //   popoverEl.__vue__.showPopper = false
      // }, 1000)
      const is_active = row.is_active === true ? 1 : 0
      updateStatus(row.id, { is_active }).then((res) => {
        if (res) {
          return this.$message.success('修改状态成功')
        }
      })
    },
    beforeSearch (params) {
      console.log('beforeSearch:', params)
      params['rule_name'] = this.keyword
      return params
    },
    onFinderResetGroup () {
      this.keyword = ''
      this.$refs.finder.refresh()
    },

    // async handleRemove (selection) {
    //   this.$message({
    //     message: `成功删除${selection.length}条记录`,
    //     type: 'success',
    //     onClose: () => {
    //       this.$refs.finder.refresh()
    //     }
    //   })
    // },

    handleClickInsert () {
      this.$message.info('点击了按钮')
    }
  }
}
</script>
<style lang="scss" scoped></style>
